<template lang="pug">
  span.product-label(
    :class="labelClass"
  )
    span {{ labelText }}
</template>

<script>

  export default {
    name: 'ProductBadge',
    components: {},
    props: {
      product: Object,
      variant: Object,
    },
    computed: {
      labelClass() {
        const downcaseTags = this.product.tags.map((tag) => tag.toLowerCase());

        if (downcaseTags.toString().includes('custom::')) {
          return 'product-label--custom'
        }

        return this.labelText ? `product-label--${this.labelText.toLowerCase().replaceAll(' ','-')}` : ''
      },
      labelText() {
        const downcaseTags = this.product.tags.map((tag) => tag.toLowerCase());

        if (this.variant.inventory_quantity <= 0 && this.variant.inventory_policy == 'deny') {
          return 'Out of Stock'
        }

        if (this.variant.price < this.variant.compare_at_price) {
          return 'Sale'
        }

        if (downcaseTags.toString().includes('custom::')) {
          for (let i = 0; i < downcaseTags.length; i++) {
            if (downcaseTags[i].includes('custom::')) {
              return downcaseTags[i].split('::')[1]
            }
          }
        }

        if (downcaseTags.includes('badge::new')) {
          return 'New'
        }

        if (downcaseTags.includes('badge::bestseller')) {
          return 'Best Seller'
        }

        if (downcaseTags.includes('badge::high protein')) {
          return 'High Protein'
        }

        return ''
      }
    }
  }
</script>